import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { Reveal } from "../components/Reveal";
import { Heart as HeartIcon } from "../components/Decor";
import Seo from "../components/Seo";

export default function MeetRachel() {
  const { settings } = useStore();
  const [page, setPage] = useState(null);

  useEffect(() => { api("/pages/meet-rachel").then(setPage).catch(() => {}); }, []);

  return (
    <div className="bg-lilac-soft min-h-screen">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-14">
        <Seo title="Meet Rachel" description="The maker behind the yarn — Rachel's story, her process and her favorite stitches." path="/meet-rachel" />
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <Reveal className="flex justify-center">
            <img src="/assets/rachel.jpg" alt="Rachel crocheting" data-testid="meet-rachel-portrait" className="w-80 h-80 object-cover rounded-[46%_54%_52%_48%/48%_46%_54%_52%] border-8 border-white shadow-card" />
          </Reveal>
          <Reveal delay={0.12}>
            <h1 data-testid="meet-rachel-heading" className="font-display font-semibold text-4xl">Hi, I'm Rachel! <HeartIcon className="inline w-8 h-8 text-candy" /></h1>
            <p className="mt-4 text-lg text-ink/70 font-semibold" data-testid="meet-rachel-bio">{settings.rachel_bio}</p>
            <div className="mt-6 rounded-3xl overflow-hidden shadow-card bg-white" data-testid="meet-rachel-video">
              <video src="/assets/rachel-review.mp4" poster="/assets/rachel-poster.jpg" controls muted playsInline loop className="w-full aspect-video object-cover" aria-label="Video of Rachel reviewing her crochet work" />
            </div>
            <p className="text-[11px] text-muted mt-2 font-semibold">Video preview clip — a production-quality clip will replace it via the admin video slot.</p>
          </Reveal>
        </div>

        <div className="mt-14 space-y-6 max-w-2xl mx-auto" data-testid="meet-rachel-story">
          {(page?.sections || []).map((s, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <h2 className="font-display font-semibold text-2xl">{s.heading}</h2>
              <p className="mt-2 text-ink/70 font-semibold leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center mt-14">
          <Link to="/custom-orders" data-testid="meet-rachel-custom-cta" className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-candy text-white font-display font-semibold text-lg shadow-pink hover:bg-candy-deep transition-colors duration-200">
            Request something special <ArrowRight className="w-5 h-5" />
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
